import React from "react";
import Footer from "./Footer";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import Header from "./Header";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <body className=" color-scheme color-scheme--scheme-1">
      <Header />
      <main className="main-content">
        <section className="featured-products">
          <div className="section-header">
            <h2>New Arrivals</h2>
          </div>
          <div className="products-grid">
            {productData.map((product) => (
              <Link
                to={`/shopDetails/${product.id}`}
                key={product.id}
                className="product-card"
                onClick={toTop}
              >
                <div className="product-image">
                  <img src={product.images[0]} alt={product.name} />
                </div>
                <div className="product-info">
                  <h3>{product.name}</h3>
                  <p className="product-price">${product.price}</p>
                </div>
              </Link>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </body>
  );
}

export default Shop;
